module.exports = __webpack_public_path__ + "static/img/introduceCType1.c7b4331.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/introduceCType1.png
// module id = 4yFs
// module chunks = 0